import React, { forwardRef, useEffect, useState } from "react";

const Textarea = forwardRef(
  (
    {
      label,
      placeholder,
      classes = "",
      labelClasses = "",
      textareaClasses = "",
      isResizable = false, // Prop to control whether the textarea is resizable
      maxCharLimit = 500, // Default max character limit
      ...props
    },
    ref
  ) => {
    const [charCount, setCharCount] = useState(0); // State for current character count
    const [text, setText] = useState(""); // State for textarea value

    // Update character count and textarea value
    const handleChange = (e) => {
      const value = e.target.value;
      if (value.length <= maxCharLimit) {
        setText(value);
        setCharCount(value.length); // Update character count
      }
    };

    // Effect to set initial text if needed
    useEffect(() => {
      setText(props.value || ""); // Initialize with props value if provided
      setCharCount((props.value || "").length); // Initialize character count
    }, [props.value]);

    return (
      <div className={classes}>
        <label
          className={`${labelClasses} mb-2 text-[12px] font-medium text-black block`}
        >
          {label}
        </label>

        <div className="relative">
          <textarea
            ref={ref}
            value={text}
            onChange={handleChange}
            placeholder={placeholder}
            className={`${textareaClasses} py-3 text-[#06152B] rounded w-full placeholder:text-500-gray text-sm focus:outline-dark-blue ${
              !isResizable ? "resize-none" : ""
            }`}
            {...props}
          ></textarea>

          <div className="absolute right-2 bottom-2 text-xs text-gray-500">
            {charCount}/{maxCharLimit}
          </div>
        </div>
      </div>
    );
  }
);

export default Textarea;
